import Vue from 'vue';
import store from '@/store';
import {MapActionsSnackbarModule} from "@/store/modules/snackbar/map-actions.snackbar";
import SinalizacaoResponse from "@/models/cliente/sinalizacao-response";
import SinalizacaoModel from "@/models/cliente/sinalizacao.model";
import FileModel from "@/models/cliente/file-model";

class SinalizacaoService {

    STATUS_OK: number = 200;

    async getAll(idCliente: number): Promise<any> {
        return await Vue.prototype.$axios.get(`contato-receptivo/cliente/${idCliente}`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const retorno: SinalizacaoResponse = response.data;
                    return retorno;
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao buscar sinalizações do cliente');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao buscar sinalizações do cliente');
            });
    }

    async salvarAnotacao(body: SinalizacaoModel): Promise<any> {
        body.data_hora = this.getDataAtualParaServico();
        return await Vue.prototype.$axios.post('contato-receptivo', body)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Anotação salva com sucesso!');
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao salvar anotação');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao salvar anotação');
            });
    }

    private getDataAtualParaServico() {
        const option = {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric', second: 'numeric'
        }
        const data = new Date().toLocaleDateString('pt-br', option).toString();
        const [dia, mes, ano]: any = data.substring(0, 10).split("/");
        const horario: any = data.substring(11, 16);
        return `${ano}-${mes}-${dia} ${horario}`;
    }

    async salvarArquivo(formData: FormData | null, idCliente: number): Promise<any> {
        return await Vue.prototype.$axios.post(`contato-receptivo/send-file/${idCliente}`, formData,
            {headers: {'Content-Type': 'multipart/form-data'}})
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Arquivo salvo com sucesso!');
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao salvar arquivo');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao salvar arquivo');
            });
    }

    async getAllArquivosClientes(idCliente: number): Promise<any> {
        return await Vue.prototype.$axios.get(`contato-receptivo/get-files/${idCliente}`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const retorno: FileModel = response.data;
                    return retorno;
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao buscar arquivos do cliente');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao buscar arquivos do cliente');
            });
    }

}

export default new SinalizacaoService();
